import React from 'react';

export default function EmailList() {
  return (
    <div>
      pending implementation
    </div>
  );
}
